
import { getAllOptions } from '@/api'

const SET_ALL_OPTIONS = 'SET_ALL_OPTIONS'

const state = {
  allOptions: null
}

const mutations = {
  [SET_ALL_OPTIONS]: (state, value) => {
    state.allOptions = value
  }
}

const actions = {
  setAllOptions({ commit }, val) {
    commit(SET_ALL_OPTIONS, val)
  },
  updateAllOptions({ commit }) {
    return new Promise((resolve, reject) => {
      getAllOptions().then(res => {
        const { status, data } = res
        commit(SET_ALL_OPTIONS, data)
        resolve(res)
      }).catch(error => {
        console.log(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}